import { createRouter, createWebHistory } from "vue-router";
import { store } from '../store'
const routes = [
  {
    path: "/",
    name: "car_lineup",
    component: ()=>import("../views/CarLineup.vue"),
  },
  {
    path: "/bodytype",
    name: "bodytype",
    component: ()=>import("../views/BodyType.vue"),
  },
  {
    path: "/engine",
    name: "engine",
    component: ()=>import("../views/Grade.vue"),
  },
  {
    path: "/grade",
    name: "grade",
    component: ()=>import("../views/Grade.vue"),
    props: true,
  },
  {
    path: "/color",
    name: "color",
    component: ()=>import("../views/Color.vue"),
  },
  {
    path: "/option",
    name: "option",
    component: ()=>import("../views/Option.vue"),
  },
  {
    path: "/simulation",
    name: "simulation",
    component: ()=>import("../views/Simulation.vue"),
  },
];

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});


// beforeEachでの処理
router.beforeEach(async(to, from) => {
  await store.dispatch("setCar");
  await store.dispatch("setSideBanner");
});

export default router;